import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IBalancesListItem } from '../types';
import {
  BALANCES_LIST_API_URL,
  BALANCES_LIST_QUERY_KEY,
  BALANCES_PERMISSIONS,
} from '../constants';

export default function useBalancesListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IBalancesListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IBalancesListItem>>({
    queryKey: [BALANCES_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IBalancesListItem>>(
      BALANCES_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: BALANCES_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
